import { useSyncExternalStore } from "react";
import { mediaLookups } from "@/lib/voice/mediaLookups";

/** True while the Genie is still looking up a link or picture to put on screen. */
export const useMediaLookupPending = (): boolean =>
  useSyncExternalStore(mediaLookups.subscribe, mediaLookups.isPending, mediaLookups.isPending);

/** True while the Genie has already shown something for a lookup and is still looking for more. */
export const useMediaLookupAddingMore = (): boolean =>
  useSyncExternalStore(mediaLookups.subscribe, mediaLookups.isAddingMore, mediaLookups.isAddingMore);
